<template>
    <div class="locale-changer">
        <select v-model="$i18n.locale">
            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
        </select>
    </div>
</template>

<script lang="ts">
export default {
    name: "LocaleSwitcher",
    data() {
        return { langs: ["fr", "en"] };
    }
};
</script>

<style scoped>
.locale-changer select {
    border: 0;
    color: var(--screenTextColor);
    background: var(--background);
}
</style>
